import {
  IInsuranceContract,
  IStandardCareProposal,
  PricingModelType,
  IStandardCareProposalProductGroupQuantity,
} from '@alberta/konexi-shared';

export function evaluateCalcMaxQuantity(
  contract: IInsuranceContract,
  standardCareProposal: IStandardCareProposal,
  productgroupId: string
): boolean {
  if ((!contract && !standardCareProposal) || !productgroupId) {
    return false;
  }

  let maxAmountProductGroup: IStandardCareProposalProductGroupQuantity;
  if (standardCareProposal) {
    maxAmountProductGroup = standardCareProposal.sortedProductGroupsWithMaxAmount.find(
      productGroup => productGroup.productGroupId === productgroupId
    );
  }

  if (isContractWithFlatCharge(contract)) {
    return true;
  } else if (maxAmountProductGroup && maxAmountProductGroup.onlyAtFlatCharge === false) {
    return true;
  } else {
    return false;
  }
}

function isContractWithFlatCharge(contract: IInsuranceContract): boolean {
  return contract && contract.pricingModelType === PricingModelType.FlatCharge;
}
